document.addEventListener('DOMContentLoaded', function () {

   if (window.wsaio_involved === true) {
    console.log("Wholesale customer detected (WSAIO) - skipping Discounty bundle logic");
    return;
  }

  console.log("Bundle Script Loaded");

  const container = document.getElementById('BundleSelector');
  const qtyInput = document.querySelector('.quantity__input');

  if (!container || !qtyInput) {
    console.log("Bundle init stopped - container or qtyInput missing");
    return;
  }

  console.log("Bundle container & quantity input found");

  const grid = container.querySelector('.bundle-grid');
  const currencySymbol = window.shopCurrency;
  const moneyFormat = window.shopMoneyFormat;

  let variantJSONs = [];
  let bundleCards = [];

  let selectedVariantPrice = window.productBasePrice || 0;
  let selectedVariantCompareAt = null;

  console.log("Initial Base Price:", selectedVariantPrice);

  // ----------------------------
  // Get Variant JSON
  // ----------------------------

  const variantScripts = container.parentNode.querySelectorAll('script[type="application/json"]');

  variantScripts.forEach(script => {
    try {
      const data = JSON.parse(script.textContent);
      if (Array.isArray(data)) {
        variantJSONs = data;
        console.log("Variant JSON Loaded:", variantJSONs.length, "variants");
      }
    } catch (e) {
      console.log("Variant JSON parse error");
    }
  });

  // ----------------------------
  // Money Format
  // ----------------------------

  function formatMoney(amount) {
    if (!moneyFormat) return amount.toFixed(2);
    let formatted = moneyFormat;
    formatted = formatted.replace(/\{\{\s*amount\s*\}\}/gi, amount.toFixed(2));
    if (currencySymbol) formatted = formatted.replace(/\{\{\s*currency\s*\}\}/gi, currencySymbol);
    formatted = formatted.replace(/\{\{.*?\}\}/g, '').trim();
    return formatted;
  }

  // ----------------------------
  // Detect Tier
  // ----------------------------

  function detectTier(qty) {
    let active = bundleCards[0];
    bundleCards.forEach(card => {
      if (qty >= parseInt(card.dataset.min)) active = card;
    });

    console.log("Active Tier Selected:", active?.dataset.min);
    return active;
  }

  // ----------------------------
  // MAIN UPDATE FUNCTION
  // ----------------------------

  function updateBundle(qty) {

    if (!bundleCards.length) {
      console.log("updateBundle skipped - no bundle cards");
      return;
    }

    if (qty < 1) qty = 1;
    qtyInput.value = qty;

    const basePrice = selectedVariantPrice;
    const active = detectTier(qty);

    bundleCards.forEach(card => card.classList.remove('active'));
    active.classList.add('active');

    const discount = parseFloat(active.dataset.discount) || 0;
    // const discountedUnit = +(basePrice * (1 - discount / 100)).toFixed(2);

    const baseCents = Math.round(basePrice * 100);
    const discountedCents = Math.round(baseCents * (100 - discount) / 100);
    const discountedUnit = discountedCents / 100;

    const subtotalEl = document.querySelector('.money-subtotal');

    if (subtotalEl) {

      // const originalSubtotal = +(basePrice * qty).toFixed(2);
      // const discountedSubtotal = +(discountedUnit * qty).toFixed(2);
      // const totalSaved = +(originalSubtotal - discountedSubtotal).toFixed(2);

      const originalSubtotalCents = baseCents * qty;
      const discountedSubtotalCents = discountedCents * qty;
      const totalSavedCents = originalSubtotalCents - discountedSubtotalCents;

      const originalSubtotal = originalSubtotalCents / 100;
      const discountedSubtotal = discountedSubtotalCents / 100;
      const totalSaved = totalSavedCents / 100;

      if (discount > 0) {

        subtotalEl.innerHTML = `
          <s class="original_total">
            ${formatMoney(originalSubtotal)}
          </s>
          <strong class="discount_total">
            ${formatMoney(discountedSubtotal)}
          </strong>
          <span class="save-badge">
            Save ${formatMoney(totalSaved)}
          </span>
        `;

      } else {

        subtotalEl.innerHTML = formatMoney(originalSubtotal);

      }
    }

    console.log("Active Discount:", discount);
    console.log("Discounted Unit:", discountedUnit);

    // ----------------------------
    // Update Bundle Cards
    // ----------------------------

    bundleCards.forEach(card => {

      const d = parseFloat(card.dataset.discount) || 0;
      // const unit = +(basePrice * (1 - d / 100)).toFixed(2);
      const unitCents = Math.round(baseCents * (100 - d) / 100);
      const unit = unitCents / 100;

      console.log(
        "Card Tier:",
        card.dataset.min,
        "| Discount:",
        d,
        "| Unit Price:",
        unit
      );

      const valueEl = card.querySelector('.bundle-price .value');
      if (valueEl) valueEl.textContent = formatMoney(unit);

      const saveEl = card.querySelector('.save-badge');

      if (saveEl) {
        saveEl.textContent = d > 0 ? `Save ${d}%` : '';
      }

    });

    let originalVariantPrice = window.productBasePrice || 0;
    let originalCompareAt = window.productCompareAtPrice || null;

    // If variant JSON exists, set for selected variant
    const firstVariant = variantJSONs[0];
    if (firstVariant) {
      originalVariantPrice = firstVariant.price / 100;
      if (firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price) {
        originalCompareAt = firstVariant.compare_at_price / 100;
      }
    }
    const priceWrapper = document.querySelector('.price');
    if (!priceWrapper) return;

    const regularPriceEl = priceWrapper.querySelector('.price__regular .price-item--regular');
    const comparePriceEl = priceWrapper.querySelector('.price__sale .price-item--regular');
    const salePriceEl = priceWrapper.querySelector('.price__sale .price-item--sale');

    let displayBase = originalVariantPrice;
    let displayCompare = originalCompareAt;

    // ===============================
    // CASE 1 → Bundle Discount Active
    // ===============================
    if (discount > 0) {
      priceWrapper.classList.add('price--on-sale');
      if (comparePriceEl) comparePriceEl.textContent = formatMoney(displayBase); // base price as compare
      if (salePriceEl) salePriceEl.textContent = formatMoney(discountedUnit);
      if (regularPriceEl) regularPriceEl.textContent = formatMoney(discountedUnit);

    // ===============================
    // CASE 2 → No Bundle, Admin Compare Exists
    // ===============================
    } else if (displayCompare) {
      priceWrapper.classList.add('price--on-sale');
      if (comparePriceEl) comparePriceEl.textContent = formatMoney(displayCompare);
      if (salePriceEl) salePriceEl.textContent = formatMoney(displayBase);
      if (regularPriceEl) regularPriceEl.textContent = formatMoney(displayBase);

    // ===============================
    // CASE 3 → Regular Price Only
    // ===============================
    } else {
      priceWrapper.classList.remove('price--on-sale');
      if (regularPriceEl) regularPriceEl.textContent = formatMoney(displayBase);
      if (comparePriceEl) comparePriceEl.textContent = '';
      if (salePriceEl) salePriceEl.textContent = '';
    }
    console.log("------------");
    console.log("Qty:", qty);
    console.log("Base Price:", displayBase);
    console.log("Compare At (Displayed):", displayCompare);
    console.log("Active Discount:", discount);
    console.log("Discounted Unit:", discountedUnit);
  }

  // ----------------------------
  // Init Bundle Cards
  // ----------------------------

  function initBundle() {

    const rows = document.querySelectorAll('.discounty-volume-discount-widget__table tbody tr');
    if (!rows.length) {
      console.log("Waiting for discount table...");
      return false;
    }

    console.log("Discount Table Found");

    const combined = [{ min: 1, discount: 0 }];

    rows.forEach(row => {
      const qtyText = row.querySelector('.discounty-volume-discount-widget__criteria')?.innerText || '';
      const discountText = row.querySelector('.discounty-volume-discount-widget__discount')?.innerText || '';

      const qty = parseInt(qtyText.replace(/\D/g, ''));
      const discount = parseFloat(discountText.replace(/[^\d.]/g, ''));

      if (!isNaN(qty) && !isNaN(discount)) {
        combined.push({ min: qty, discount: discount });
      }
    });

    combined.sort((a, b) => a.min - b.min);

    console.log("Tier Data:", combined);

    grid.innerHTML = '';

    combined.forEach(item => {
      const card = document.createElement('div');
      card.className = 'bundle-card';
      card.dataset.min = item.min;
      card.dataset.discount = item.discount;
      // Add highlight only if item.min matches the one you want, or show for first card
      const highlight = (item.min === 10 && window.bundleHighlightText) ? `<span class="bundle-highlight">${window.bundleHighlightText}</span>` : '';

      card.innerHTML = `
        <h4 class="card-bundle-title">BUY ANY ${item.min}+</h4>
         ${highlight}
        <div class="bundle-price">
          <span class="value">0</span>
          <span class="prefix">/ea</span>
        </div>
        <span class="save-badge"></span>
      `;

      grid.appendChild(card);
    });

    bundleCards = [...grid.querySelectorAll('.bundle-card')];

    console.log("Bundle Cards Created:", bundleCards.length);

    bundleCards.forEach(card => {
      card.addEventListener('click', function () {
        console.log("🖱 Bundle Card Clicked:", this.dataset.min);
        qtyInput.value = this.dataset.min;
        qtyInput.dispatchEvent(new Event('change'));
      });
    });

    updateBundle(parseInt(qtyInput.value) || 1);

    return true;
  }

  // ----------------------------
  // Quantity Events
  // ----------------------------

  function handleQtyChange() {
    console.log("Quantity Changed:", qtyInput.value);
    updateBundle(parseInt(qtyInput.value) || 1);
  }

  qtyInput.addEventListener('input', handleQtyChange);
  qtyInput.addEventListener('change', handleQtyChange);

  document.addEventListener('click', function(e) {
    if (e.target.closest('.btn-quantity')) {
      setTimeout(handleQtyChange, 50);
    }
  });

  // ----------------------------
  // Variant Change
  // ----------------------------

  function handleVariantChange(variantId) {

    console.log("====== VARIANT CHANGED ======");

    const variant = variantJSONs.find(v => v.id == variantId);
    if (!variant) {
      console.log("Variant not found");
      return;
    }

    console.log("Variant ID:", variantId);
    console.log("Variant Price:", variant.price / 100);
    console.log("Variant Compare At:", variant.compare_at_price);

    selectedVariantPrice = variant.price / 100;

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      selectedVariantCompareAt = formatMoney(variant.compare_at_price / 100);
    } else {
      selectedVariantCompareAt = null;
    }

    console.log("Updated Base Price:", selectedVariantPrice);
    console.log("Updated Compare At:", selectedVariantCompareAt);

    updateBundle(parseInt(qtyInput.value) || 1);
  }

  container.parentNode.querySelectorAll('input[type="radio"][data-variant-id]').forEach(radio => {
    radio.addEventListener('change', function () {
      handleVariantChange(parseInt(this.dataset.variantId));
    });
  });

  container.parentNode.querySelectorAll('select').forEach(select => {
    select.addEventListener('change', function () {
      handleVariantChange(parseInt(this.value));
    });
  });

  const observer = new MutationObserver(() => {
    if (initBundle()) {
      console.log("Bundle Initialized Successfully");
      observer.disconnect();
    }
  });
  

  observer.observe(document.body, { childList: true, subtree: true });

  // ----------------------------
  // Reset bundle selection after full page load
  // ----------------------------
  window.addEventListener('load', function () {
    console.log("Window fully loaded → resetting bundle selection");

    const qtyInput = document.querySelector('.quantity__input');
    const container = document.getElementById('BundleSelector');
    if (!qtyInput || !container) return;

    const bundleCards = container.querySelectorAll('.bundle-card');
    if (!bundleCards.length) return;

    // Reset quantity to 1
    qtyInput.value = 1;

    // Remove active class from all cards
    bundleCards.forEach(card => card.classList.remove('active'));

    // Select the first bundle card (min 1)
    const firstCard = bundleCards[0];
    firstCard.classList.add('active');

    // Update UI (subtotal + bundle prices) using your existing function
    if (typeof updateBundle === "function") {
      updateBundle(1); // quantity 1
    }
  });

  function handleVariantChange(variantId) {
    console.log("====== VARIANT CHANGED ======");

    const variant = variantJSONs.find(v => v.id == variantId);
    if (!variant) {
      console.log("Variant not found");
      return;
    }

    console.log("Variant ID:", variantId);
    console.log("Variant Price:", variant.price / 100);
    console.log("Variant Compare At:", variant.compare_at_price);

    selectedVariantPrice = variant.price / 100;

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      selectedVariantCompareAt = formatMoney(variant.compare_at_price / 100);
    } else {
      selectedVariantCompareAt = null;
    }

    console.log("Updated Base Price:", selectedVariantPrice);
    console.log("Updated Compare At:", selectedVariantCompareAt);

    // ----------------------------
    // Reset qty and first bundle card like page load
    // ----------------------------
    const qtyInput = document.querySelector('.quantity__input');
    const container = document.getElementById('BundleSelector');
    if (qtyInput && container) {
      const bundleCards = container.querySelectorAll('.bundle-card');
      if (bundleCards.length) {
        qtyInput.value = 1; // reset qty
        bundleCards.forEach(card => card.classList.remove('active')); // remove all active
        bundleCards[0].classList.add('active'); // select first
      }
    }

    // Update bundle UI with qty 1
    if (typeof updateBundle === "function") {
      updateBundle(1);
    }
  }

  

});

document.addEventListener('DOMContentLoaded', function () {
  if (window.wsaio_involved === true) {

    document.querySelectorAll('.cart-discounts').forEach(el => el.remove());
    console.log("Wholesale cart detected - hiding Discounty cart portal");

    // Hide Discounty cart portal and discount labels permanently
    const style = document.createElement('style');
    style.innerHTML = `
      .discounty-portal,
      .cart-discounts,
      .upcart-discount-code-badge {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }
});

